/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The SystemControllerDtoSysMaintenanceInfoResponse model module.
 * @module model/SystemControllerDtoSysMaintenanceInfoResponse
 * @version 1.0
 */
class SystemControllerDtoSysMaintenanceInfoResponse {
    /**
     * Constructs a new <code>SystemControllerDtoSysMaintenanceInfoResponse</code>.
     * @alias module:model/SystemControllerDtoSysMaintenanceInfoResponse
     */
    constructor() { 
        
        SystemControllerDtoSysMaintenanceInfoResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoSysMaintenanceInfoResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoSysMaintenanceInfoResponse} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoSysMaintenanceInfoResponse} The populated <code>SystemControllerDtoSysMaintenanceInfoResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoSysMaintenanceInfoResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('maintenanceNo')) {
                obj['maintenanceNo'] = ApiClient.convertToType(data['maintenanceNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('isUrgent')) {
                obj['isUrgent'] = ApiClient.convertToType(data['isUrgent'], 'Boolean');
            }
            if (data.hasOwnProperty('startedAt')) {
                obj['startedAt'] = ApiClient.convertToType(data['startedAt'], 'Date');
            }
            if (data.hasOwnProperty('endedAt')) {
                obj['endedAt'] = ApiClient.convertToType(data['endedAt'], 'Date');
            }
            if (data.hasOwnProperty('createAt')) {
                obj['createAt'] = ApiClient.convertToType(data['createAt'], 'Date');
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoSysMaintenanceInfoResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoSysMaintenanceInfoResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['version'] && !(typeof data['version'] === 'string' || data['version'] instanceof String)) {
            throw new Error("Expected the field `version` to be a primitive type in the JSON string but got " + data['version']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} maintenanceNo
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['maintenanceNo'] = undefined;

/**
 * @member {String} title
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['title'] = undefined;

/**
 * @member {String} content
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['content'] = undefined;

/**
 * @member {Boolean} isUrgent
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['isUrgent'] = undefined;

/**
 * @member {Date} startedAt
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['startedAt'] = undefined;

/**
 * @member {Date} endedAt
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['endedAt'] = undefined;

/**
 * @member {Date} createAt
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['createAt'] = undefined;

/**
 * @member {String} version
 */
SystemControllerDtoSysMaintenanceInfoResponse.prototype['version'] = undefined;






export default SystemControllerDtoSysMaintenanceInfoResponse;

